module.exports = __webpack_public_path__ + "static/zeroinit-96803e9d110336773dd56f77e2ed3389.png";